/** @format */

import { ComponentFactory, ComponentFactoryResolver, NgModule } from '@angular/core';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconMoneyScorecard,
	homefieldIconMoneyScorecardGold
} from '@dsg-tech/homefield-angular-icons';

import { AuthLinkModule } from '@shared/authentication/utils';
import { CommonModule } from '@angular/common';
import { ScorecardPointsComponent } from './scorecard-points.component';
import { ToolTipModule } from '@shared/components';

/**
 * ScorecardPointsModule
 */
@NgModule({
	declarations: [ScorecardPointsComponent],
	imports: [AuthLinkModule, CommonModule, HomefieldIconLibraryModule, ToolTipModule],
	exports: [ScorecardPointsComponent]
})
export class ScorecardPointsModule {
	constructor(
		private componentFactoryResolver: ComponentFactoryResolver,
		homefieldIconsLibraryService: HomefieldIconsLibraryService
	) {
		homefieldIconsLibraryService.registerIcons([
			homefieldIconMoneyScorecard,
			homefieldIconMoneyScorecardGold
		]);
	}
	public resolveComponentFactory(): ComponentFactory<ScorecardPointsComponent> {
		return this.componentFactoryResolver.resolveComponentFactory(ScorecardPointsComponent);
	}
}
